import {BomParameter} from "../types/configuration";

export function buildValueWithUnit(parameter: BomParameter) {
  const value = parameter.translatedValue?.toString()
  const unit = parameter.translatedUnit || "";

  return value?.concat(unit);
}